import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddPaymentPlanLayer from "../../components/PaymentPlans/AddPaymentPlanLayer";




const AddPaymentPlanPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  title="Add Payment Plan" />

        {/* Add Project Layer */}
        <AddPaymentPlanLayer />

      </MasterLayout>
    </>
  );
};

export default AddPaymentPlanPage;
